import { METAL_CLASS, METAL_WEIGHT_DEST_CLASS, ORIGINAL_NAME_LONG_ATTR, ITEM_DESC_CLASS } from './productChange';
import { querySelector, querySelectorId, querySelectorAll } from './querySelectors';
import { WEIGHT_SYMBOL, U_DN_CLASS } from '../config/main';

const METAL_DEST_CLASS = 'product-metal-detail';
const METAL_WEIGHT_ATTR = 'data-weight';
const CHAIN_SOURCE_ID = 'product-choose-chain_length';
const CHAIN_LENGTH_ATTR = 'data-chain_length';
const CHAIN_LENGTH_DEST_CLASS = 'js-chain_length';
const CHAIN_TYPE_DEST_CLASS = 'js-chain_type';
const CHAIN_TYPE_ATTR = 'data-chain_type';
const CHAIN_WIDTH_DEST_CLASS = 'js-chain_width';
const CHAIN_WIDTH_ATTR = 'data-chain_width';
const DYNAMIC_ATTRIBUTE_ATTR_PATTERN = 'data-detail-';
const DYNAMIC_ATTRIBUTE_CLASS_PATTERN = 'js-detail-id-';
const URL_ATTR = 'data-url';

let chainSelect = false;
let metalSelect = false;

let getWrapper = function(item) {
  return item.closest(`.${ITEM_DESC_CLASS}`);
};

let hideAttribute = function(item) {
  let wrapper = getWrapper(item);

  if (wrapper) {
    wrapper.classList.add(U_DN_CLASS);
  }
};

let showAttribute = function(item) {
  let wrapper = getWrapper(item);

  if (wrapper) {
    wrapper.classList.remove(U_DN_CLASS);
  }
};

let getEditableAttrValues = function() {
  return window.editable_attr_values ? window.editable_attr_values : [];
};

let getMetalSelect = function() {
  if (metalSelect !== false) {
    return metalSelect;
  }

  metalSelect = querySelector(`.${METAL_CLASS}`);
  return metalSelect;
};

let getChainSelect = function() {
  if (chainSelect !== false) {
    return chainSelect;
  }

  chainSelect = querySelectorId(CHAIN_SOURCE_ID);
  return chainSelect;
};

let getText = function(option, checkLong) {
  if (checkLong && option.getAttribute(ORIGINAL_NAME_LONG_ATTR)) {
    return option.getAttribute(ORIGINAL_NAME_LONG_ATTR);
  }

  return option.textContent;
};

let setSelectValue = function(source, destSelector, checkLong = false, link) {
  if (source && source.value !== '') {
    let dests = querySelectorAll(destSelector);

    dests.forEach((dest) => {
      if (link) {
        dest.innerHTML = `<a href="${link}">${getText(source.options[source.options.selectedIndex], checkLong)}</a>`;
      }
      else {
        dest.textContent = getText(source.options[source.options.selectedIndex], checkLong);
      }
    });
  }
};

let setOptionAttributeValue = function(source, attr, destSelector, suffix = '') {
  let dest = querySelector(destSelector);

  if (source && source.value !== '') {
    let data = source.options[source.options.selectedIndex].getAttribute(attr);

    if (data && dest) {
      showAttribute(dest);
      dest.textContent = `${data} ${suffix}`;
      return;
    }
  }
};

let setMetal = function() {
  let select = getMetalSelect();

  if (select) {
    let url = select.options[select.options.selectedIndex].getAttribute(URL_ATTR);

    setSelectValue(select, `.${METAL_DEST_CLASS}`, true, url);
  }
};

let setChainLength = function() {
  setOptionAttributeValue(getChainSelect(), CHAIN_LENGTH_ATTR, `.${CHAIN_LENGTH_DEST_CLASS}`);
};

let setChainType = function() {
  setOptionAttributeValue(getChainSelect(), CHAIN_TYPE_ATTR, `.${CHAIN_TYPE_DEST_CLASS}`);
};

let setChainWidth = function() {
  setOptionAttributeValue(getChainSelect(), CHAIN_WIDTH_ATTR, `.${CHAIN_WIDTH_DEST_CLASS}`);
};

let setWeight = function() {
  setOptionAttributeValue(getMetalSelect(), METAL_WEIGHT_ATTR, `.${METAL_WEIGHT_DEST_CLASS}`, WEIGHT_SYMBOL);
};

let setDynamicRange = function() {
  let attrs = getEditableAttrValues();

  attrs.forEach((attr) => {
    let item = querySelector(`option[${DYNAMIC_ATTRIBUTE_ATTR_PATTERN}${attr}]:checked`);

    if (item) {
      setOptionAttributeValue(
        item.closest('select'),
        `${DYNAMIC_ATTRIBUTE_ATTR_PATTERN}${attr}`,
        `.${DYNAMIC_ATTRIBUTE_CLASS_PATTERN}${attr}`
      );
    }
    else {
      let dest = querySelector(`.${DYNAMIC_ATTRIBUTE_CLASS_PATTERN}${attr}`);

      if (dest) {
        hideAttribute(dest);
      }
    }
  });
};

export default function() {
  setMetal();
  setChainLength();
  setChainType();
  setChainWidth();
  setWeight();
  setDynamicRange();
}
